import bdReq from '../../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../../@packages/@bd-uikit-web/js-helpers/bdAuth';

import {
  FETCH_MOBILE_QUEUE_REQUEST,
  FETCH_MOBILE_QUEUE_SUCCESS,
  FETCH_MOBILE_QUEUE_FAILURE,
  FETCH_MOBILE_STATUS_REQUEST,
  FETCH_MOBILE_STATUS_SUCCESS,
  FETCH_MOBILE_STATUS_FAILURE
} from '../constants/mobileConstants';

const fetchMobileQueueRequest = () => ({ type: FETCH_MOBILE_QUEUE_REQUEST });
const fetchMobileQueueSuccess = (payload) => ({ type: FETCH_MOBILE_QUEUE_SUCCESS, payload });
const fetchMobileQueueFailure = (errors) => ({ type: FETCH_MOBILE_QUEUE_FAILURE, errors });

const fetchMobileStatusRequest = () => ({ type: FETCH_MOBILE_STATUS_REQUEST });
const fetchMobileStatusSuccess = (payload) => ({ type: FETCH_MOBILE_STATUS_SUCCESS, payload });
const fetchMobileStatusFailure = (errors) => ({ type: FETCH_MOBILE_STATUS_FAILURE, errors });

export const fetchMobileStatus = (deviceId) => async (dispatch) => {
  dispatch(fetchMobileStatusRequest());
  try {
    const tokens = bdAuth.getToken();
    const url = `/v2/devices/${deviceId}/status`;
    const response = await bdReq.get(url);
    // const response = await bdReq.post(`/users/${tokens?.user}/devices/${deviceId}/play`);
    if (response.status === 200 && response.success) {
      return dispatch(fetchMobileStatusSuccess(response.body));
    }
    else if (response.status === 400) {
      return dispatch(fetchMobileStatusFailure("Bad Request"));
    }
    else if (response.status === 404) {
      return dispatch(fetchMobileStatusFailure("Device Unregistered"));
    }
    else {
      return dispatch(fetchMobileStatusFailure(response.body.message));
    }
  } catch (e) {
    return dispatch(fetchMobileStatusFailure(e));
  }
};

export const fetchMobileQueue = (deviceId) => async (dispatch) => {
  dispatch(fetchMobileQueueRequest());
  try {
    const tokens = bdAuth.getToken();
    // const url = `/devices/${deviceId}`;
    const url = `/v2/devices/${deviceId}/queue` 
    const response = await bdReq.get(url);
    // const response = await bdReq.post(`/users/${tokens?.user}/devices/${deviceId}/play`);
    if (response.status === 200 && response.success) {
      return dispatch(fetchMobileQueueSuccess(response.body));
    }
    else if (response.status === 400) {
      return dispatch(fetchMobileQueueFailure("Device Unregistered"));
    }
    else if (response.status === 404) {
      return dispatch(fetchMobileQueueFailure("Error"));
    }
    else {
      return dispatch(fetchMobileQueueFailure(response.body.message));
    }
  } catch (e) {
    return dispatch(fetchMobileQueueFailure(e));
  }
};
